import { render, staticRenderFns } from "./MutuusIcon.vue?vue&type=template&id=7980f016&scoped=true"
import script from "./MutuusIcon.vue?vue&type=script&lang=js"
export * from "./MutuusIcon.vue?vue&type=script&lang=js"
import style0 from "./MutuusIcon.vue?vue&type=style&index=0&id=7980f016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980f016",
  null
  
)

export default component.exports